import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const CommonNavBarRect = (props) => {
  const { decodedToken } = props;
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null);

  useEffect(() => {
    // Retrieve the active menu from localStorage on load
    const savedMenu = localStorage.getItem("activeMenu");
    if (savedMenu) {
      setActiveMenu(savedMenu);
    }
  }, []);

  const toggleMenu = (menuId) => {
    if (activeMenu === menuId) {
      // Close the menu if it's already open
      setActiveMenu(null);
      localStorage.removeItem("activeMenu");
    } else {
      // Open the selected menu
      setActiveMenu(menuId);
      localStorage.setItem("activeMenu", menuId);
    }
  };
  return (
    <>
      <>
        {decodedToken?.UsrRoleId === 16 &&
          <li className="nav-item">
            <a
              className="nav-link menu-link"
              href="#clientrequest"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls="clientrequest"
            >
              <i className="ri-rocket-line"></i>
              <span data-key="t-clients">Request</span>
            </a>
            <div className="collapse menu-dropdown" id="clientrequest">
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link
                    to="/client-request-in-dm"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    All Request{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </li>
        }
        <li className="nav-item">
          <a
            className="nav-link menu-link"
            href="#infrequest"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="sidebarVideos"
          >
            <i className="ri-rocket-line"></i>
            <span data-key="t-videos">Sub Request</span>
          </a>
          <div className="collapse menu-dropdown" id="infrequest">
            <ul className="nav nav-sm flex-column">
              <li className="nav-item">
                <Link
                  to="/suggested-influencer"
                  className={`nav-link`}
                  data-key="t-ecommerce"
                >
                  Influencer Sub Request
                </Link>
              </li>
            </ul>
          </div>
        </li>
        {decodedToken?.UsrRoleId === 16 && 
          <li className="nav-item">
            <Link
              className="nav-link menu-link"
              to="/suggested-inf-list"
            >
              <i className="ri-dashboard-2-line"></i>
              <span data-key="t-dashboard">Suggested Influencer</span>
            </Link>
          </li>
        }
        <li className="nav-item">
          <a
            className="nav-link menu-link"
            href="#dmexecutive"
            data-bs-toggle="collapse"
            role="button"
            aria-expanded="false"
            aria-controls="dmexecutive"
          >
            <i className="ri-rocket-line"></i>
            <span data-key="t-clients">Influencer</span>
          </a>
          <div className="collapse menu-dropdown" id="dmexecutive">
            <ul className="nav nav-sm flex-column">
              {/* <li className="nav-item">
                  <Link
                    to="/active-influencer"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Active Influencer{" "}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/assigned-influencer"
                    className="nav-link"
                    data-key="t-ecommerce"
                  >
                    Assigned Influencer
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/pending-influencer"
                    className="nav-link"
                    data-key="t-analytics"
                  >
                    Pending Influencer{" "}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/inactive-influencer"
                    className="nav-link"
                    data-key="t-crm"
                  >
                    Inactive Influencer{" "}
                  </Link>
                </li> */}
              <li className="nav-item">
                <Link
                  to="/all-influencer"
                  className="nav-link"
                  data-key="t-ecommerce"
                >
                  All Influencer
                </Link>
              </li>

            </ul>
          </div>
        </li>

      </>
    </>
  );
};

export default CommonNavBarRect;
